const NEW_JOINEE_TABLE_READY = "newJoinee-table-ready"
const SEARCH_TEXT_STATE = "newJoinee-table-search-text-state"
const ROWS_PER_PAGE_STATE = "newJoinee-table-rows-per-page-state"
const PAGINATION_STATE = "newJoinee-table-pagination-state"

const EMPLOYEE_DATA_FOR_ACTION = "newJoinee-employee-data-for-action"


//const ADD_EMPLOYEE_MOVEMENT_READY = "newJoinee-table-add-newJoinee-ready"


const PREVIOUS_NEW_JOINEE_FILTER_START_DATE = "new-joinee-previous-start-date"
const PREVIOUS_NEW_JOINEE_FILTER_END_DATE = "new-joinee-previous-end-date"


const PREVIOUS_NEW_JOINEE_WORK_LOCATION_ID = "newjoinee-previous-work-location-id"

const PREVIOUS_NEW_JOINEE_FILTER_CITY_ID = "newjoinee-previous-filter-city-id"

const PREVIOUS_NEW_JOINEE_STATUS = "newjoinee-previous-filter-status"

const initialState = {
    isNewJoineeTableReady: true,
    newJoinee: {},


    previousFilterStartDate: "",
    previousFilterEndDate: "",
    
    employeeSelectedData: {},
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousWorkLocationId: "",

    previousFilterCity:"",

    previousFilterStatus:"",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case NEW_JOINEE_TABLE_READY:
            return Object.assign({}, state, { isNewJoineeTableReady: action.payload })

            
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)


        case PREVIOUS_NEW_JOINEE_FILTER_START_DATE:
            return Object.assign({}, state, {previousFilterStartDate:action.payload})
        case PREVIOUS_NEW_JOINEE_FILTER_END_DATE:
            return Object.assign({}, state, {previousFilterEndDate:action.payload})

        case EMPLOYEE_DATA_FOR_ACTION:
            return Object.assign({}, state, {employeeSelectedData:action.payload})


        case PREVIOUS_NEW_JOINEE_WORK_LOCATION_ID:
            return Object.assign({}, state, {previousWorkLocationId:action.payload})

        case PREVIOUS_NEW_JOINEE_FILTER_CITY_ID:
            return Object.assign({}, state, {previousFilterCity:action.payload})

        case PREVIOUS_NEW_JOINEE_STATUS:
            return Object.assign({}, state, {previousFilterStatus:action.payload})

        default:
        return state
    
    }

}

export function newJoineeTableReady(data) {
    return {
        type: NEW_JOINEE_TABLE_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function newJoineeDataForAction(newJoineeId){
    return{
        type:EMPLOYEE_DATA_FOR_ACTION,
        payload:newJoineeId
    }
}


export function previousFilterStartDate(fiter_val){
    return{
        type:PREVIOUS_NEW_JOINEE_FILTER_START_DATE,
        payload:fiter_val
    }
}


export function previousFilterEndDate(fiter_val){
    return{
        type:PREVIOUS_NEW_JOINEE_FILTER_END_DATE,
        payload:fiter_val
    }
}


export function previousWorkLocationId(fiter_val){
    return{
        type:PREVIOUS_NEW_JOINEE_WORK_LOCATION_ID,
        payload:fiter_val
    }
}
export function previousFilterCity(fiter_val){
    return{
        type:PREVIOUS_NEW_JOINEE_FILTER_CITY_ID,
        payload:fiter_val
    }
}

export function previousFilterStatus(fiter_val){
    return{
        type:PREVIOUS_NEW_JOINEE_STATUS,
        payload:fiter_val
    }
}



// WEBPACK FOOTER //
// ./src/modules/New Joinee/redux/newjoinee.js